import React from "react";
import './events.scss';
import babyDino from '../../assets/bebe-dino.png';
import calendar from '../../assets/calendar.svg';

function Events() {

    //month is index of array of months
    const streamingDate = new Date(Date.UTC(2023, 6, 11, 19, 0, 0)); // ACTUALIZAR CON LA QUE CORREPONDA
    const adoptionDate = new Date(Date.UTC(2023, 5, 7, 12, 0, 0));

    return (
        <section id="eventos" className="scroller">
            <h3>Eventos</h3>
            <div className="background">
                <article>
                    <div>
                        <h4>Estreno del documental "Un día cualquiera en Triassic Park"</h4>
                        <p className="event-date">
                            <img src={calendar} height={30} alt='icono de calendario'/>
                            <span className="dates">{streamingDate.toLocaleString()}</span>
                            <span>[Este evento ya ha pasado]</span>
                        </p>
                        <p>
                            ¿Quieres ver como es un día de trabajo en Triassic Park? ¡Lo que los visitantes NO ven!<br/>
                            Situado en un enclave espectacular dónde tanto tú como los dinosaurios os encontraréis como en casa. Ven, conócelos, haz amigos y vuelve siempre que quieras.
                            Tienes disponible un descuento en la compra del billete de avión con la compra de tu entrada.
                        </p>
                    </div>
                    <iframe width="560" height="315" src="https://www.youtube.com/embed/ss7lShL6w6U?si=8dIXR_6Y2Ebnuph-" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                </article>
            </div>
            <div className="background">
                <article>
                    <div>
                        <h4>¡Adopta un dinosaurio!</h4>
                        <p className="event-date">
                            <img src={calendar} height={30} alt='icono de calendario'/>
                            <span className="dates">{adoptionDate.toLocaleString()}</span>
                            <span>[Este evento ya ha pasado]</span>
                        </p>
                        <p>
                            <span>[AHORA MISMO TODOS NUESTROS DINOSAURIOS ESTÁN ADOPTADOS]*</span> <br/>
                            <small>*Puedes adoptar un Jacin <a href="https://ko-fi.com/jacinmaeron" target="blank">aquí</a></small><br/>
                            <br/>
                            Ven a pasar el día, disfruta de los más pequeñines y ¡adopta a tu favorito!<br/>
                            Este es un evento benéfico en el que recogemos fondos para mejorar la vida de nuestros animales. Al adoptar a uno de nuestros animales recibirás mensualmente un pack de fotos, un relieve de su pisada para que puedas seguir su crecimiento, un vídeo de la hora de la comida y una carta con los sucesos más relevantes del mes.
                        </p>
                    </div>
                    <img src={babyDino} alt='Bebe dinosaurio con chupete'/>
                </article>
            </div>
            
        
        </section>
    );
}

export default Events;
